angular
  .module("AccountingBoxApp")
  .controller("OpenPurchasesCtrl", function(
    $scope,
    $http,
    $state,
    FileUploader,
    LoopBackAuth,
    Journal,
    Account,
    Rapporting
  ) {
    $scope.order = {
      by: "invoiceDate",
      reverse: false,
      filter: ""
    };

    var vm = this;
    vm.search = "";
    vm.loading = false;

    vm.date = new Date();

    vm.filterData = function(){
      vm.purchases = vm.result.openCredit.purchases;
      vm.payments = vm.result.openCredit.payments;
      if(vm.search) {
        let search = vm.search.toLowerCase()
        vm.purchases = vm.purchases.filter(function(p) {
          return p.vendor.name.toLowerCase().includes(search)
        })
        vm.payments = vm.payments.filter(function(p) {
          return p.invoice.vendor.name.toLowerCase().includes(search)
        })
      }

      vm.totalInvoiceAmount = vm.purchases.reduce(function(
        accumulator,
        invoice
        ) {
          return accumulator + invoice.totalAmount;
        },
        0);
      vm.totalAmountDue = 0;
      vm.totalAmountDue = vm.purchases.reduce(function(accumulator, invoice) {
        return accumulator + invoice.amountDue;
      }, vm.totalAmountDue);
      vm.totalAmountDue = vm.payments.reduce(function(accumulator, payment) {
        return accumulator - payment.amount;
      }, vm.totalAmountDue);
    }

    vm.result = null
    vm.dataChanged = function() {
      vm.loading = true;
      Rapporting.openCredit({ date: vm.date }, function(result) {
        vm.result = result;
        vm.loading = false;
        vm.filterData()
      });
    };
    // vm.dataChanged();

    vm.toTransaction = function(journalLine) {
      Journal.findById({ id: journalLine.journalId }, function(journal) {
        var to = journal.transactionType.toLowerCase() + "s";
        if (journal.transactionType.toLowerCase() === "journalentry") {
          to = "journalEntries";
        }
        $state.go("app.company.edit." + to, {
          id: journal.transactionId
        });
      });
    };

    vm.today = function() {
      return moment().format("L");
    };
  });
